import {
	getLastSrpUrlFromStorage,
	LAST_SRP_ACTIVITY_STORAGE_KEY,
	LAST_SRP_URL_STORAGE_KEY
} from '~/composables/lastSrpUrl/utils';

export function useLastSrpUrl() {
	const lastSrpUrl = ref<string | null>(null);

	function syncLastSrpUrl() {
		lastSrpUrl.value = getLastSrpUrlFromStorage();
	}

	if (import.meta.client) {
		const handleStorage = (event: StorageEvent) => {
			if (
				event.key !== LAST_SRP_URL_STORAGE_KEY &&
				event.key !== LAST_SRP_ACTIVITY_STORAGE_KEY
			) {
				return;
			}

			syncLastSrpUrl();
		};

		onMounted(() => {
			syncLastSrpUrl();
			window.addEventListener('storage', handleStorage);
		});

		onUnmounted(() => {
			window.removeEventListener('storage', handleStorage);
		});
	}

	return {
		lastSrpUrl: readonly(lastSrpUrl),
		hasLastSrpUrl: computed(() => !!lastSrpUrl.value),
		syncLastSrpUrl
	};
}
